import React from 'react';
import { VE_BANK_ASSETS } from '../lib/brand';
type VeeMascotProps = {
  size?: number;
  state?: 'idle' | 'speaking' | 'listening';
  className?: string;
  /** Marks the companion as decorative when nearby copy already names Vee. */
  decorative?: boolean;
};
export function VeeMascot({
  size = 64,
  state = 'idle',
  className = '',
  decorative = false
}: VeeMascotProps) {
  const source = state === 'listening' ? VE_BANK_ASSETS.veeListening : VE_BANK_ASSETS.vee;
  return <span className={`relative inline-flex items-center justify-center ${className}`} style={{
    width: size,
    height: size
  }} data-id="element-161" data-mp="2tw2nj7qjxwjo">
      {state !== 'idle' && <span aria-hidden="true" className={`vee-status absolute h-[40%] w-[40%] rounded-full ${state === 'listening' ? 'bg-brand-electric/60' : 'bg-brand-purple/45'}`} data-id="element-162" data-mp="2ky8q1th1wwux" />}
      <img src={source} alt={decorative ? '' : "Vee, VE Bank's assistant"} aria-hidden={decorative || undefined} width={size} height={size} className="relative z-10 h-full w-full select-none object-contain" draggable={false} data-id="element-163" data-mp="2azb2asrg97cz" />
    </span>;
}